import "./index.css";

//import AboutMe from "./components/AboutMe";

import {Routes, Route, useLocation} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "./components/Navbar";
import Contact from "./pages/Contact";
import Education from "./pages/Education";
import Experience from "./pages/Experience";
import Projects from "./pages/Projects";
import Home from "./pages/Home";



export default function App() {
  const location = useLocation();
  return (
    <>
      <Navbar/>
      
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home/>}/>
          <Route path="/experience" element={<Experience/>}/>
          <Route path="/education" element={<Education/>}/>
          <Route path="/projects" element={<Projects/>}/>
          <Route path="/contact" element={<Contact/>}/>
        </Routes>
      </AnimatePresence>
      
       {/* <section className="min-h-screen bg-[#0D1117] text-white px-6 py-20">
          <AboutMe/>
       </section> */}
    </>
  );
}
